import React from 'react';

export function Numpad({ onKeyPress, onDelete, onSubmit, isLoading }) {
  const buttons = ["1", "2", "3", "4", "5", "6", "7", "8", "9", ".", "0"];

  const handleSubmit = () => {
    if (onSubmit) {
      onSubmit();
    }
  };

  return (
    <div className="w-full flex flex-col items-center">
      <div className="grid grid-cols-3 gap-3 mb-4 w-full max-w-xs">
        {buttons.map((char, idx) => (
          <button
            key={idx}
            type="button"
            onClick={() => onKeyPress(char)}
            disabled={!char || isLoading}
            className="w-20 h-20 bg-white/5 hover:bg-white/10 border border-white/10 hover:border-green-500/50 text-white text-2xl font-mono font-semibold transition-all active:scale-95 disabled:opacity-50 disabled:cursor-not-allowed"
          >
            {char}
          </button>
        ))}
        <button
          type="button"
          onClick={onDelete}
          disabled={isLoading}
          className="w-20 h-20 bg-white/5 hover:bg-white/10 border border-white/10 hover:border-green-500/50 text-white text-xl font-semibold transition-all active:scale-95 disabled:opacity-50 flex items-center justify-center"
        >
          <span className="material-symbols-outlined">backspace</span>
        </button>
      </div>

      <button
        type="button"
        onClick={handleSubmit}
        disabled={isLoading}
        className="w-full max-w-xs h-14 bg-green-500 hover:bg-white text-black font-bold uppercase tracking-widest text-lg transition-all active:scale-95 disabled:opacity-50 shadow-[0_0_15px_rgba(34,197,94,0.3)] hover:shadow-[0_0_25px_#00ff41]"
      >
        {isLoading ? "PROCESSING..." : "PAY NOW"}
      </button>
    </div>
  );
}
